import styled from 'styled-components';

export const Address = styled.div`
  display: flex;
  align-items: center;
  svg {
    width: 1.2em;
    margin-right: ${(props) => props.theme.spacing.tiny};
  }
  margin-bottom: ${(props) => props.theme.spacing.standard};
`;
